import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import * as utils from '@ivy/fts/utils';
import { env } from '@ivy/fts/envInfo/envInfo';
import AreacodePanel from './areacodePanel.vue';
import config from '@/config';
let BindPhone = class BindPhone extends Vue {
    constructor() {
        super(...arguments);
        this.bind = {
            mobile: '',
            vercode: '',
        };
        this.area = {
            area_code: '+86',
            area_code_id: '1',
        };
        this.showPanel = false;
        this.loading = false;
        this.queryObj = {};
        this.getCode = {
            text: '获取验证码',
            geting: false,
        };
    }
    setAreaCode(area) {
        this.area = area;
        this.showPanel = false;
    }
    async openAreaCode() {
        this.showPanel = true;
    }
    get codeStyle() {
        return {
            color: this.getCode.geting ? '#CCCCCC' : '#00B097',
        };
    }
    getPhone() {
        return this.bind.mobile
            .split(' ')
            .join('')
            .split('-')
            .join('');
    }
    async bindMobile() {
        if (this.loading) {
            return;
        }
        if (!this.bind.mobile) {
            return this.$Toast('请输入手机号');
        }
        if (!this.bind.vercode) {
            return this.$Toast('请输入短信验证码');
        }
        this.loading = true;
        let code = utils.cacheGet(`code-${config.appid}`);
        await this.$axios.post(`/api/core/user/login/wechatBindPhone`, {
            code: code,
            area_code_id: this.area.area_code_id,
            sms_code: this.bind.vercode,
            phone: this.getPhone(),
        });
        await env.init();
        if (!(await env.getIsLogin())) {
            // 绑定手机号失败
            this.loading = false;
            return;
        }
        this.$Toast('手机号绑定成功');
        window.location.reload();
        this.toCancel();
    }
    async countDown() {
        this.getCode.geting = true;
        for (let count = 60; count > 0; count--) {
            this.getCode.text = `重新获取  ${count}s`;
            await utils.sleep(1000);
        }
        this.getCode = {
            text: '获取验证码',
            geting: false,
        };
    }
    async toGetCode() {
        // 获取验证码
        if (this.getCode.geting)
            return;
        if (!this.bind.mobile) {
            return this.$Toast('请输入手机号');
        }
        let { data: { code, message }, } = await utils.sendSmsCode(+this.area.area_code_id, this.getPhone());
        if (code) {
            return this.$Toast('验证码发送失败！' + message);
        }
        this.$Toast('验证码发送成功');
        this.countDown();
    }
    toCancel() {
        this.$emit('cancelFn');
    }
};
BindPhone = tslib_1.__decorate([
    Component({
        components: {
            AreacodePanel,
        },
    })
], BindPhone);
export default BindPhone;
